import { useRef } from "react"
import { SDKContextType } from "../../context/types"

const useMeetingClient = () => {
  const meetingClient = useRef<SDKContextType>(
    window.MeetOnline.client()
  ).current

  return meetingClient
}

export const useMeetingClientRef = () => {
  const meetingClientRef = useRef<SDKContextType>(
    window.MeetOnline.client()
  )

  return meetingClientRef
}

export default useMeetingClient
